export default function() {
    jQuery('.potw-menu-item').each(function() {
        let $e = jQuery(this);
        
        $e.on('mouseleave', function() {
            let i = setInterval(function(){
                if($e.is(':hover')) return;
                
                $e.removeClass('anim-1 anim-2 anim-3');
                $e.addClass('anim-' + parseInt(Math.floor(Math.random() * (3 - 1 + 1)) + 1, 10));

                clearInterval(i);
            }, 800);
        })
    })
}